import React from 'react';
import './OurValues.css';

function OurValues() {
  return (
    <div className="our-values-page">
      {/* Hero Banner */}
      <div className="values-hero">
        <div className="values-hero-content">
          <h1>OUR VALUES</h1>
          <p>Guiding Principles That Define The Shapes United</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="values-content">
        <div className="values-container">
          {/* Introduction */}
          <p className="values-intro">
            At The Shapes United we're motivated by our biggest goals: personal agency, good health and well-being, ultimate comfort and sustainability.
          </p>
          
          <p className="values-intro">
            Our values permeate our supply chain, our product range and underpin everything we do. If it isn't win-win-win, we don't do it.
          </p>

          {/* Bullet Points Section */}
          <div className="values-list">
            <h2>Our Core Values in Action</h2>
            
            <div className="bullet-points">
              <div className="bullet-item">
                <span className="bullet">•</span>
                <div className="bullet-content">
                  <p><strong>Personal Agency & Independence:</strong> The Shapes United helps with temporary or long-term movement impairment, allowing fast and easy access for carers, when and where it's needed, whilst preserving personal agency and comfort.</p>
                </div>
              </div>

              <div className="bullet-item">
                <span className="bullet">•</span>
                <div className="bullet-content">
                  <p><strong>Rigorous Testing:</strong> Each item in our range has undergone rigorous testing, iterations and trials in real world environments to make it the best it can be for users.</p>
                </div>
              </div>

              <div className="bullet-item">
                <span className="bullet">•</span>
                <div className="bullet-content">
                  <p><strong>Innovative Design:</strong> Our magnetised fasteners limit the range of movement needed to get dressed and undressed independently. Toilet accidents become a thing of the past; re-injury risks reduce.</p>
                </div>
              </div>

              <div className="bullet-item">
                <span className="bullet">•</span>
                <div className="bullet-content">
                  <p><strong>Style Meets Function:</strong> The products are stylish as well as practical. The Shapes United looks like ordinary everyday wear. Anyone can wear it, and no one would ever know that it isn't regular gym gear or street clothes.</p>
                </div>
              </div>

              <div className="bullet-item">
                <span className="bullet">•</span>
                <div className="bullet-content">
                  <p><strong>Enhancing Lives:</strong> We are excited to help people to live out their best and most active lives. The Shapes United delivers independence and comfort, helping people feel good as they look. The product replaces purpose-purchased, improvised, oversized High street fashion – the kind that creates a trip hazard.</p>
                </div>
              </div>

              <div className="bullet-item">
                <span className="bullet">•</span>
                <div className="bullet-content">
                  <p><strong>Sustainability & Ethics:</strong> Our products are Fair Trade manufactured and ethically and sustainably produced. Once the item wears out, patients can return it to us for recycling into a new product.</p>
                </div>
              </div>

              <div className="bullet-item">
                <span className="bullet">•</span>
                <div className="bullet-content">
                  <p><strong>Win-Win Philosophy:</strong> Helping one person shouldn't come at the cost of harm to another. It's why we adopted ethical and sustainable practices wherever we can across our supply chain.</p>
                </div>
              </div>
            </div>
          </div>

          {/* Sustainability Link */}
          <div className="sustainability-link">
            <p>More about our sustainability practices <a href="/sustainability" className="link">here</a>.</p>
          </div>

          {/* Feedback Section */}
          <div className="feedback-section">
            <h2 className="feedback-title">FEEDBACK</h2>
            <p className="feedback-text">
              We would really appreciate to hear more from you. Feel free to email us at <a href="mailto:hello@theshapesunited.com" className="email-link">hello@theshapesunited.com</a> with any thoughts or you are welcome to complete our online survey <a href="/survey" className="link">here</a>.
            </p>
            
            <p className="feedback-note">
              Helping one person shouldn't come at the cost of harm to another. It's why we adopted ethical and sustainable practices wherever we can across our supply chain.
            </p>
            
            <div className="cta-buttons">
              <a href="mailto:hello@theshapesunited.com" className="email-btn">
                Email Us
              </a>
              <a href="/survey" className="survey-btn">
                Take Survey
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurValues;